export default "__VITE_ASSET__DygH4W1U__"